
import textsEn from '../../app/languages/en.json'

import {
  CHANGE_LANGUAGE,
  LOGIN_BY_PARAMETERS_FROM_URL,
  SELECT_COLOR_THEME,
  SET_LANGUAGE_RESOURCE,
  SET_ACCOUNT_TIME_ZONE,
  USE_PARAMS_FROM_URL,
  SHOW_FULL_SCREEN_SPINNER,
  HIDE_FULL_SCREEN_SPINNER,
  OPEN_POPUP,
  CLOSE_POPUP,
  SHOW_LOADING_BAR,
} from '../actions/appActions'
import {
  CHANGE_LOGIN,
  CHANGE_PASSWOND,
  LOGIN,
  LOGOUT,
  LOGIN_ERROR,
} from '../../pages/login/loginActions'

const isBrowserHasDarkTheme = window.matchMedia('(prefers-color-scheme: dark)').matches;

const initialState = {
  language: 'en',
  texts: textsEn,
  account: {
    accountName: '',
    password: '',
    passwordMD5: '',
    timeZone: 'America/New_York',
  },
  colorTheme: isBrowserHasDarkTheme ? 'darkMode' : 'lightBlue',
  paramsFromUrl: {},
  isShowFullScreenSpinner: false,
  popupParams: {
    isOpen: false,
    text: '',
    btns1: [],
    btns2: [],
  },
  loadingBarParams: {
    total: 1,
    first: 1,
    second: 0,
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case USE_PARAMS_FROM_URL:
      return { ...state, paramsFromUrl: { ...state.paramsFromUrl, ...payload } }
    case CHANGE_LANGUAGE:
      return { ...state, language: payload }
    case SET_LANGUAGE_RESOURCE:
      return { ...state, texts: payload }
    case SET_ACCOUNT_TIME_ZONE:
      return {
        ...state,
        account: { ...state.account, timeZone: payload.timeZone },
      }
    case SELECT_COLOR_THEME:
      return { ...state, colorTheme: payload }
    case SHOW_LOADING_BAR:
      return { ...state, loadingBarParams: payload }

    /* LOGIN */
    case LOGIN_BY_PARAMETERS_FROM_URL:
      return { ...state,
        account: {
          accountName: payload.accountName.trim(),
          password: '',
          passwordMD5: payload.passwordMD5,
        },
      }
    case CHANGE_LOGIN:
      return { ...state, account: { ...state.account, accountName: payload } }
    case CHANGE_PASSWOND:
      return { ...state, account: { ...state.account, password: payload } }
    case LOGIN:
      return { ...state,
        account: {
          accountName: payload.accountName.trim(),
          password: payload.password,
          passwordMD5: payload.passwordMD5,
        },
        isShowFullScreenSpinner: true,
      }
    case LOGOUT:
      return { ...state, account: { ...state.account, password: '', passwordMD5: '' } }
    case LOGIN_ERROR:
      return { ...state, account: { ...state.account, passwordMD5: '' } }

    /* FULL_SCREEN_SPINNER */
    case SHOW_FULL_SCREEN_SPINNER:
      return { ...state, isShowFullScreenSpinner: true }
    case HIDE_FULL_SCREEN_SPINNER:
      return { ...state, isShowFullScreenSpinner: false }

    /* POPUP */
    case OPEN_POPUP:
      return { ...state, popupParams: { isOpen: true, ...payload } }
    case CLOSE_POPUP:
      return { ...state, popupParams: initialState.popupParams }

    default:
      return state
  }
}
